import React from 'react';

import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepConfig} from 'pipelines/PipelineTypes';
import {ButtonSize} from 'ui-library/buttons/Button';
import ToggleGroup from 'ui-library/ToggleGroup';

type IsInputX = PipelineStepConfig<PipelineStepType.REGRESSION_INTERPOLATION, 0, 'draft'>['isInputX'];

/** @package */
export enum IsInputXOption {
  X = 'x',
  Y = 'y',
}

export default function IsInputXToggleGroup({
  config,
  onChangeConfig,
}: {
  config: IsInputX;
  onChangeConfig: (newConfig: IsInputX) => void;
}): JSX.Element {
  const selection = config === false ? IsInputXOption.Y : IsInputXOption.X;
  function onChangeSelection(newSelection: IsInputXOption): void {
    if (newSelection === IsInputXOption.X) {
      onChangeConfig(true);
    } else {
      onChangeConfig(false);
    }
  }

  return (
    <ToggleGroup<IsInputXOption>
      options={[
        {id: IsInputXOption.X, buttonProps: {text: 'Use inputs as X to predict Y'}},
        {id: IsInputXOption.Y, buttonProps: {text: 'Use inputs as Y to predict X'}},
      ]}
      selection={selection}
      onChangeSelection={onChangeSelection}
      size={ButtonSize.MEDIUM}
    />
  );
}
